import customVideoWidget from './widgets/customVideoWidget.js'; // Import the widget loader function

let initialized = false;

// Initialize the video tabs and widgets only on the homepage
function initializeTabs() {
  const tabContainer = $('<div class="video-tab-container"></div>');
  const videoContentContainer = $('<div class="video-content-container"></div>');
  $('#kist').append(tabContainer);
  $('#kist').append(videoContentContainer);
  tabContainer.append(`
    <a id="videoOneTab" class="videoTab activeTab" data-video-tab="videoOne">Livestream 1</a>
    <a id="videoTwoTab" class="videoTab" data-video-tab="videoTwo">Livestream 2</a>
  `);
  videoContentContainer.append(`
    <div id="videoOne" class="videoContainer"></div>
    <div id="videoTwo" class="videoContainer" style="display:none;"></div>
  `);
  $('.videoTab').on('click', function () {
    const tab = $(this).attr('data-video-tab');
    switchTab(tab);
  });

  initialized = true;
}

// Switch between video tabs
function switchTab(tabName) {
  $('.videoContainer').hide();
  $('.videoTab').removeClass('activeTab');

  $(`#${tabName}`).show();
  $(`#${tabName}Tab`).addClass('activeTab');

  loadVideoWidget(tabName);
}

// Load the video widget for the selected tab
function loadVideoWidget(tabName) {
  if (tabName === 'videoOne') {
    customVideoWidget('videoOne', videoOneOpts);
  } else if (tabName === 'videoTwo') {
    customVideoWidget('videoTwo', videoTwoOpts);
  }
}

// Initialize the tabs and load the default video tab
function initialize() {
  if (!initialized) {
    initializeTabs();
  }

  loadVideoWidget('videoOne');
}

// Check if the current page is the homepage ("/")
// Initialize the widget functionality only on the homepage
if (window.location.pathname === '/') {
  $(document).ready(function () {
    initialize();
  });
}
